import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { BehaviorSubject, Observable } from 'rxjs';

import { AuthModalComponent } from '../components/auth-modal/auth-modal.component';

export type AuthTab = 'signin' | 'signup';

@Injectable({
  providedIn: 'root'
})
export class AuthModalService {
  private isModalOpen = false;
  private isOpenSubject = new BehaviorSubject<boolean>(false);
  isOpen$: Observable<boolean> = this.isOpenSubject.asObservable();

  constructor(private modalController: ModalController) {}

  async openAuthModal(
    defaultTab: AuthTab = 'signup',
    alertMessage = '',
    dismissible = false
  ): Promise<void> {
    if (this.isModalOpen) {
      return;
    }
    this.isModalOpen = true;
    this.isOpenSubject.next(true);
    const modal = await this.modalController.create({
      component: AuthModalComponent,
      componentProps: { defaultTab, alertMessage, dismissible },
      cssClass: 'auth-modal-wrapper',
      backdropDismiss: dismissible
    });
    await modal.present();
    await modal.onDidDismiss();
    this.isModalOpen = false;
    this.isOpenSubject.next(false);
  }

  async dismissAuthModal(): Promise<void> {
    if (this.isModalOpen) {
      await this.modalController.dismiss();
      this.isModalOpen = false;
      this.isOpenSubject.next(false);
    }
  }

  isOpen(): boolean {
    return this.isModalOpen;
  }
}
